<div class="dialog__wrapper">
  <div mat-dialog-title class="dialog__header-container">
    <div class="dialog__header">
      <h4 class="dialog__title">Third Parties</h4>
      <button mat-dialog-close mat-icon-button>
        <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
      </button>
    </div>
    <mat-form-field subscriptSizing="dynamic" class="dialog__filter">
      <mat-label>Search...</mat-label>
      <input type="text" matInput [formControl]="filter" />
    </mat-form-field>
  </div>
  <mat-dialog-content class="dialog__content">
    <p class="dialog__description">
      Most organisations send SMS message directly to a Bulk SMS Provider. However, a 3rd Party is sometimes used to send messages to a Bulk SMS Provider on behalf of the organisation.
    </p>
    <p>
      Only Assign a 3rd Party if you are actually using one. In the next step you will need to select your Bulk SMS Providers (OPAs).
    </p>
    <p>
      If you are not sure if you are using a 3rd Party or not please contact your messaging provider.
    </p>

    <form [formGroup]="form">
      <div>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="thirdParty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Third Party Name</th>
            <td mat-cell *matCellDef="let element">{{ element.organisationName }}</td>
          </ng-container>
  
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Allowed</th>
            <td mat-cell *matCellDef="let element;">
              <mat-checkbox [formControl]="getFormArrayControl(element.organisationName)"></mat-checkbox>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
  
          <tr *matNoDataRow>
            <td colspan="2">Third Parties list is empty</td>
          </tr>
        </table>
        
        <mat-paginator [pageSizeOptions]="TableConstants.dialogPageSize" aria-label="Page size"></mat-paginator>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button type="button" (click)="handleClose()" class="button--secondary button--pad-right">Close</button>
    <button mat-raised-button type="button" (click)="handleConfirm()">Save</button>
  </mat-dialog-actions>
</div>
